export const validatePaymentValue = (value: string): boolean => {
  const numericValue = parseFloat(value.replace(',', '.'))
  return numericValue > 5
}

export const validateName = (name: string): boolean => {
  return name.trim().length >= 3
}

export const validateDocument = (document: string): boolean => {
  const numericValue = document.replace(/\D/g, '')
  return numericValue.length === 11 || numericValue.length === 14
}

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

export const validatePhone = (phone: string): boolean => {
  const numericValue = phone.replace(/\D/g, '')
  return numericValue.length === 10 || numericValue.length === 11
}

export const validateZipCode = (zipCode: string): boolean => {
  const numericValue = zipCode.replace(/\D/g, '')
  return numericValue.length === 8
}

export const validateCardNumber = (cardNumber: string): boolean => {
  const numericValue = cardNumber.replace(/\D/g, '')
  return numericValue.length >= 13
}

export const validateCardExpiry = (expiry: string): boolean => {
  const expiryRegex = /^(0[1-9]|1[0-2])\/\d{2}$/
  return expiryRegex.test(expiry)
}

export const validateCardCvv = (cvv: string): boolean => {
  return cvv.length >= 3 && cvv.length <= 4
}

export const validateRequired = (value: string): boolean => {
  return value.trim() !== ''
}

export const getValidationError = (fieldId: string, value: string): string => {
  switch (fieldId) {
    case 'payment-value':
      return !validatePaymentValue(value)
        ? 'Por favor, insira um valor válido para o pagamento, valor mínimo R$ 5,00'
        : ''
    case 'customer-name':
      return !validateName(value)
        ? 'Por favor, insira seu nome completo (mínimo 3 caracteres)'
        : ''
    case 'customer-document':
      return !validateDocument(value)
        ? 'Por favor, insira um CPF (11 dígitos) ou CNPJ (14 dígitos) válido'
        : ''
    case 'customer-email':
      return !validateEmail(value)
        ? 'Por favor, insira um endereço de e-mail válido'
        : ''
    case 'customer-phone':
      return !validatePhone(value)
        ? 'Por favor, insira um número de telefone válido com DDD'
        : ''
    case 'customer-zipcode':
      return !validateZipCode(value)
        ? 'Por favor, insira um CEP válido (8 dígitos)'
        : ''
    case 'customer-address':
      return !validateRequired(value)
        ? 'Por favor, insira um endereço válido'
        : ''
    case 'customer-number':
      return !validateRequired(value)
        ? 'Por favor, insira o número do endereço'
        : ''
    case 'customer-neighborhood':
      return !validateRequired(value)
        ? 'Por favor, insira um bairro válido'
        : ''
    case 'customer-city':
      return !validateRequired(value)
        ? 'Por favor, insira uma cidade válida'
        : ''
    case 'customer-state':
      return !validateRequired(value) ? 'Por favor, selecione um estado' : ''
    case 'card-number':
      return !validateCardNumber(value)
        ? 'Por favor, insira um número de cartão válido'
        : ''
    case 'card-expiry':
      return !validateCardExpiry(value)
        ? 'Por favor, insira uma data de validade válida (MM/AA)'
        : ''
    case 'card-cvv':
      return !validateCardCvv(value)
        ? 'Por favor, insira um código de segurança válido'
        : ''
    case 'card-holder':
      return !validateName(value)
        ? 'Por favor, insira o nome como está no cartão'
        : ''
    default:
      return ''
  }
}
